import React from "react";

export default function Privacidad() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      {/* Contenedor principal tipo documento */}
      <main className="flex-1">
        <div className="max-w-5xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
          {/* Encabezado del documento */}
          <div className="bg-white/90 backdrop-blur-xl border border-slate-200 rounded-2xl shadow-sm px-6 sm:px-8 py-6 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <p className="text-xs uppercase tracking-[0.18em] text-emerald-600 font-semibold mb-1">
                AsisControl · Portal de Asistencia
              </p>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
                Políticas de Privacidad
              </h1>
              <p className="text-xs sm:text-sm text-slate-500 mt-1">
                Versión 1.0 · Última actualización: 1 de enero de 2026
              </p>
            </div>
            <div className="flex items-center gap-2 self-start sm:self-auto">
              <span className="inline-flex items-center gap-2 rounded-full bg-emerald-50 border border-emerald-100 px-3 py-1">
                <span className="h-2 w-2 rounded-full bg-emerald-500" />
                <span className="text-xs font-medium text-emerald-700">
                  En cumplimiento Ley 19.628 (Chile)
                </span>
              </span>
            </div>
          </div>

          {/* Bloque de contenido */}
          <div className="bg-white/95 backdrop-blur-xl border border-slate-200 rounded-2xl shadow-sm p-6 sm:p-8 space-y-10 text-slate-700 leading-relaxed">
            {/* 1. Introducción */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                1. Introducción
              </h2>
              <p>
                AsisControl es una plataforma web diseñada para el registro y
                control de asistencia laboral, turnos y horarios, utilizada por
                empresas para la gestión diaria de sus equipos. La protección de
                los datos personales de los usuarios es una prioridad, por lo
                que esta política describe cómo se recopila, utiliza y protege
                la información asociada al uso del sistema.
              </p>
              <p className="mt-2">
                Al utilizar esta aplicación para registrar asistencia, revisar
                horarios o gestionar reportes, aceptas las prácticas descritas
                en esta política de privacidad.
              </p>
            </section>

            {/* 2. Responsable */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                2. Responsable del tratamiento de datos
              </h2>
              <p>
                El responsable del tratamiento de los datos personales es la
                empresa que contrata y administra el sistema AsisControl, quien
                actúa como empleador y controlador de la información de sus
                trabajadores.
              </p>
              <p className="mt-2">
                AsisControl actúa como proveedor tecnológico, procesando los
                datos únicamente según las instrucciones de la empresa
                empleadora, manteniendo medidas de seguridad adecuadas para
                resguardar la información.
              </p>
            </section>

            {/* 3. Datos recopilados */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                3. Datos personales que recopilamos
              </h2>

              <div className="grid gap-4 sm:gap-6 sm:grid-cols-2">
                <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4">
                  <h3 className="text-sm font-semibold text-slate-900 mb-1">
                    3.1. Datos de identificación
                  </h3>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    <li>Nombre y apellido.</li>
                    <li>Correo electrónico corporativo o de contacto.</li>
                    <li>Nombre de usuario.</li>
                    <li>Identificador interno del sistema (UUID).</li>
                  </ul>
                </div>

                <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4">
                  <h3 className="text-sm font-semibold text-slate-900 mb-1">
                    3.2. Datos laborales
                  </h3>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    <li>
                      Registros de asistencia (fecha, hora de entrada y salida).
                    </li>
                    <li>Jornadas, turnos y horarios asignados.</li>
                    <li>Observaciones asociadas a la jornada.</li>
                    <li>
                      Tipo de contrato y parámetros necesarios para el control
                      de asistencia.
                    </li>
                  </ul>
                </div>

                <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4">
                  <h3 className="text-sm font-semibold text-slate-900 mb-1">
                    3.3. Datos técnicos
                  </h3>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    <li>Dirección IP aproximada.</li>
                    <li>Identificador del dispositivo o navegador.</li>
                    <li>Información de sesión (tokens de autenticación).</li>
                  </ul>
                </div>

                <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-4">
                  <h3 className="text-sm font-semibold text-slate-900 mb-1">
                    3.4. Datos de ubicación
                  </h3>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    <li>
                      Ubicación geográfica solo al momento de marcar asistencia,
                      utilizada para validar el lugar de trabajo.
                    </li>
                    <li>
                      No se realiza seguimiento continuo en segundo plano.
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* 4. Finalidad */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                4. Finalidad del tratamiento de los datos
              </h2>
              <p>Los datos personales se utilizan exclusivamente para:</p>
              <ul className="list-disc list-inside space-y-1 mt-1">
                <li>Registrar y controlar asistencia laboral diaria.</li>
                <li>Gestionar turnos, horarios y ausencias.</li>
                <li>
                  Generar reportes de asistencia y métricas administrativas.
                </li>
                <li>
                  Cumplir obligaciones legales y contractuales del empleador.
                </li>
                <li>
                  Garantizar la seguridad y correcto funcionamiento del sistema.
                </li>
              </ul>
              <p className="mt-2">
                Los datos no se utilizan con fines comerciales, publicitarios ni
                de marketing externo.
              </p>
            </section>

            {/* 5. Base legal */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                5. Base legal del tratamiento (Chile)
              </h2>
              <p>
                El tratamiento de datos se realiza conforme a la Ley N° 19.628,
                basándose en:
              </p>
              <ul className="list-disc list-inside space-y-1 mt-1">
                <li>
                  La relación laboral existente entre trabajador y empleador y
                  la necesidad de registrar asistencia y cumplimiento horario.
                </li>
                <li>
                  El consentimiento informado del trabajador al utilizar el
                  sistema.
                </li>
                <li>
                  El cumplimiento de obligaciones legales y laborales del
                  empleador.
                </li>
              </ul>
            </section>

            {/* 6. Usuarios / 7. Acceso */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                6. Creación y gestión de usuarios
              </h2>
              <p>
                Los usuarios no se registran de manera autónoma. Las cuentas son
                creadas y administradas exclusivamente por la empresa
                empleadora, quien define roles, accesos y credenciales según las
                funciones de cada trabajador.
              </p>
            </section>

            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                7. Acceso y control de la información
              </h2>
              <p>Cada usuario puede:</p>
              <ul className="list-disc list-inside space-y-1 mt-1">
                <li>
                  Acceder a su historial de asistencias registrado en el
                  sistema.
                </li>
                <li>Revisar sus datos personales básicos almacenados.</li>
                <li>
                  Solicitar correcciones o actualizaciones al administrador de
                  la empresa.
                </li>
              </ul>
              <p className="mt-2">
                Solo usuarios autorizados (por ejemplo, administradores o
                encargados de RR.HH.) pueden gestionar o visualizar información
                de otros trabajadores.
              </p>
            </section>

            {/* 8. Seguridad */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                8. Seguridad de la información
              </h2>
              <p>
                AsisControl implementa medidas técnicas y organizativas para
                proteger los datos, tales como:
              </p>
              <ul className="list-disc list-inside space-y-1 mt-1">
                <li>
                  Autenticación mediante tokens seguros (JWT) para acceso a la
                  plataforma.
                </li>
                <li>Comunicación cifrada mediante HTTPS.</li>
                <li>Control de acceso por roles y perfiles de usuario.</li>
                <li>Políticas de seguridad y respaldo de base de datos.</li>
                <li>Revisión periódica de accesos y actividad inusual.</li>
              </ul>
            </section>

            {/* 9. Conservación */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                9. Conservación de los datos
              </h2>
              <p>
                Los datos personales se conservan mientras exista la relación
                laboral y durante el tiempo requerido por la normativa vigente o
                por las políticas internas del empleador en materia de control
                de asistencia y obligaciones legales.
              </p>
            </section>

            {/* 10. Compartición */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                10. Compartición de datos
              </h2>
              <p>
                Los datos no son compartidos con terceros, salvo en los
                siguientes casos:
              </p>
              <ul className="list-disc list-inside space-y-1 mt-1">
                <li>Cuando sea requerido por una autoridad competente.</li>
                <li>Para cumplir obligaciones legales o laborales.</li>
                <li>
                  Para servicios técnicos estrictamente necesarios para la
                  operación del sistema (por ejemplo, infraestructura en la nube
                  o servicios de base de datos).
                </li>
              </ul>
            </section>

            {/* 11. Derechos */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                11. Derechos de los titulares de datos
              </h2>
              <p>
                De acuerdo con la normativa vigente, los usuarios pueden ejercer
                sus derechos de acceso, rectificación, cancelación y oposición
                (ARCO) sobre su información personal.
              </p>
              <p className="mt-2">
                Para ejercer estos derechos, el trabajador debe contactar al
                administrador del sistema dentro de su empresa o al área de
                Recursos Humanos correspondiente.
              </p>
            </section>

            {/* 12. Menores */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                12. Uso por menores de edad
              </h2>
              <p>
                AsisControl no está destinado al uso por menores de edad sin
                autorización expresa del empleador y sin el cumplimiento de la
                normativa laboral vigente aplicable a cada país.
              </p>
            </section>

            {/* 13. Cambios */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                13. Cambios en esta política de privacidad
              </h2>
              <p>
                Esta política puede actualizarse para reflejar cambios legales,
                técnicos o funcionales en la plataforma. Las modificaciones
                serán informadas a los usuarios a través de la aplicación o por
                medio de la empresa administradora, actualizando la fecha de
                "Última actualización" indicada en este documento.
              </p>
            </section>

            {/* 14. Contacto / dudas */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">
                14. Contacto y dudas
              </h2>
              <p>
                Si tienes preguntas sobre el uso de tus datos dentro de
                AsisControl, o deseas ejercer alguno de tus derechos, debes
                comunicarte con la empresa que administra el sistema o con el
                área de soporte indicada internamente.
              </p>

              <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div>
                  <p className="font-medium text-slate-900">
                    ¿Tienes alguna duda sobre tus registros de asistencia?
                  </p>
                  <p className="text-slate-600">
                    Ponte en contacto con Recursos Humanos o con el
                    administrador de AsisControl en tu empresa.
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-medium px-4 py-2 shadow-sm transition-colors"
                  >
                    Contactar soporte interno
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white/80 backdrop-blur mt-6">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} La Metalera — AsisControl V2. Todos los
            derechos reservados.
          </p>
          <p className="text-[11px] text-slate-400">
            Esta política de privacidad se aplica exclusivamente al uso del
            sistema de control de asistencia AsisControl.
          </p>
        </div>
      </footer>
    </div>
  );
}
